import api from "../atlasApi";

export const serviceGetTeam = (data) => {
  return api.post("/horizon/get-team/", data, {
    headers: {
      Authorization: "Token ea0bb95d88829a5174bae4657242c5c48e121228",
      "Content-Type": "multipart/form-data",
    },
  });
};

export const serviceAddEditTeam = (data) => {
  return api.post("/horizon/add-edit-team/", data, {
    headers: {
      Authorization: "Token ea0bb95d88829a5174bae4657242c5c48e121228",
      "Content-Type": "multipart/form-data",
    },
  });
};
